import { ShouldErrorBeIgnored } from "./Utils/General/Errors.js";
/** For any field in baseMap that extendMap lacks, mutate extendMap to include it; equivalent to Object.assign(extendMap, baseMap, {...extendMap}). */
function ExtendObjectMap_StoredInExtendMap(baseMap, extendMap) {
    if (extendMap == null)
        return baseMap;
    for (const [key, value] of Object.entries(baseMap)) {
        if (!(key in extendMap)) {
            extendMap[key] = value;
        }
    }
}
export class Manager {
    constructor() {
        this.colors = {};
        this.zIndexes = { subNavBar: 11 };
        this.ShouldErrorBeIgnored = ShouldErrorBeIgnored;
    }
    /*onPopulated = new Promise((resolve, reject)=>this.onPopulated_resolve = resolve);
    onPopulated_resolve: Function;*/
    //Populate(data: Omit<Manager, "onPopulated" | "onPopulated_resolve" | "Populate">) {
    Populate(data) {
        const oldData = { ...this };
        this.Extend(data);
        // use these helpers, such that the object-reference remains the same as the object sent in (thus the caller can mutate the values easily later)
        ExtendObjectMap_StoredInExtendMap(oldData.colors, data.colors);
        ExtendObjectMap_StoredInExtendMap(oldData.zIndexes, data.zIndexes);
        //G({Log: Log}); // set globals
        //this.onPopulated_resolve();
        OnPopulated_listeners.forEach(a => a());
    }
    // shortcuts
    get store() { return this.GetStore(); }
}
export const manager = new Manager();
export const OnPopulated_listeners = [];
export function OnPopulated(listener) { OnPopulated_listeners.push(listener); }
// globals
/*declare global {
    //function Log(message, appendStackTrace?: boolean, logLater?: boolean);
    function Log(options: LogOptions, ...messageSegments: any[]);
    function Log(...messageSegments: any[]);
}*/ 
//# sourceMappingURL=Manager.js.map